import { createI18n } from 'vue-i18n';
import messages from '@/translations/messages';

export function setupI18n(authStore) {
  return createI18n({
    locale: authStore.getLocale,
    fallbackLocale: 'en',
    messages,
  });
}
